export const defaultHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

// Auth

export const AUTHENTICATED = 'AUTHENTICATED';
export const SIGNED_OUT = 'SIGNED_OUT';
export const AUTH_EXPIRED = 'AUTH_EXPIRED';

export const AUTH_INIT = 'AUTH_INIT';
export const AUTH_INIT_SUCCESS = 'AUTH_INIT_SUCCESS';
export const AUTH_INIT_ERROR = 'AUTH_INIT_ERROR';

export const AUTH_SIGN_IN = 'AUTH_SIGN_IN';
export const AUTH_SIGN_IN_SUCCESS = 'AUTH_SIGN_IN_SUCCESS';
export const AUTH_SIGN_IN_ERROR = 'AUTH_SIGN_IN_ERROR';

export const AUTH_SIGN_OUT = 'AUTH_SIGN_OUT';
export const AUTH_SIGN_OUT_SUCCESS = 'AUTH_SIGN_OUT_SUCCESS';
export const AUTH_SIGN_OUT_ERROR = 'AUTH_SIGN_IN_ERROR';

export const ADMINISTRATOR_PASSWORD_CHANGE = 'ADMINISTRATOR_PASSWORD_CHANGE';
export const ADMINISTRATOR_PASSWORD_CHANGE_SUCCESS = 'ADMINISTRATOR_PASSWORD_CHANGE_SUCCESS';
export const ADMINISTRATOR_PASSWORD_CHANGE_ERROR = 'ADMINISTRATOR_PASSWORD_CHANGE_ERROR';

export const AUTH_PASSWORD_RESET_REQUEST = 'AUTH_PASSWORD_RESET_REQUEST';
export const AUTH_PASSWORD_RESET_REQUEST_SUCCESS = 'AUTH_PASSWORD_RESET_REQUEST_SUCCESS';
export const AUTH_PASSWORD_RESET_REQUEST_ERROR = 'AUTH_PASSWORD_RESET_REQUEST_ERROR';

export const AUTH_PASSWORD_RESET = 'AUTH_PASSWORD_RESET';
export const AUTH_PASSWORD_RESET_SUCCESS = 'AUTH_PASSWORD_RESET_SUCCESS';
export const AUTH_PASSWORD_RESET_ERROR = 'AUTH_PASSWORD_RESET_ERROR';

// Notifications

export const NOTIFICATIONS_ADD = 'NOTIFICATIONS_ADD';
export const NOTIFICATIONS_SET = 'NOTIFICATIONS_SET';
export const NOTIFICATIONS_REMOVE = 'NOTIFICATIONS_REMOVE';
export const NOTIFICATIONS_CLEAR = 'NOTIFICATIONS_CLEAR';

//
// Dashboard
//

export const DASHBOARD_DATA_LOAD = 'DASHBOARD_DATA_LOAD';
export const DASHBOARD_DATA_LOAD_SUCCESS = 'DASHBOARD_DATA_LOAD_SUCCESS';
export const DASHBOARD_DATA_LOAD_ERROR = 'DASHBOARD_DATA_LOAD_ERROR';

//
// Game Definitions
//

export const MODEL_GAME_DEFINITION = 'GAME_DEFINITION';

//
// Game Nodes
//

export const MODEL_GAME_NODE = 'GAME_NODE';

//
// Knowledge Options
//

export const MODEL_KNOWLEDGE_OPTION = 'KNOWLEDGE_OPTION';

//
// Lecturers
//

export const MODEL_LECTURER = 'LECTURER';

//
// Game Instances
//

export const MODEL_GAME_INSTANCE = 'GAME_INSTANCE';

//
// Game Answers
//

export const MODEL_GAME_ANSWER = 'GAME_ANSWER';

//
// Game Submissions
//

export const MODEL_GAME_SUBMISSION = 'GAME_SUBMISSION';

//
// Knowledge Questions
//

export const MODEL_KNOWLEDGE_QUESTION = 'KNOWLEDGE_QUESTION';

export const KNOWLEDGE_QUESTION_OPTIONS_LOAD = 'KNOWLEDGE_QUESTION_OPTIONS_LOAD';
export const KNOWLEDGE_QUESTION_OPTIONS_LOAD_SUCCESS = 'KNOWLEDGE_QUESTION_OPTIONS_LOAD_SUCCESS';
export const KNOWLEDGE_QUESTION_OPTIONS_LOAD_ERROR = 'KNOWLEDGE_QUESTION_OPTIONS_LOAD_ERROR';

//
// Bonus Tasks
//

export const MODEL_BONUS_TASK = 'BONUS_TASK';

//
// Creative Tasks
//

export const MODEL_CREATIVE_TASK = 'CREATIVE_TASK';

//
// Administrator
//

export const ADMINISTRATOR = 'ADMINISTRATOR';

// =====================================================================================================================

export const NAMESPACE_ADMIN = 'admin';

// Action Names

export const ACTION_LIST = 'LOAD';
export const ACTION_SELECT = 'SELECT';
export const ACTION_CREATE = 'CREATE';
export const ACTION_UPDATE = 'UPDATE';
export const ACTION_DESTROY = 'DESTROY';
export const ACTION_CLONE = 'CLONE';
export const ACTION_INVALIDATE = 'INVALIDATE';

// Helpers

export const resourceAction = (modelName, actionName) => {
    return `${modelName}_${actionName}`;
};

export const resourceActionSuccess = (modelName, actionName) => {
    return `${resourceAction(modelName, actionName)}_SUCCESS`;
};

export const resourceActionError = (modelName, actionName) => {
    return `${resourceAction(modelName, actionName)}_ERROR`
};

export const resourcesAction = (modelName, actionName) => {
    return `${modelName}S_${actionName}`;
};

export const resourcesActionSuccess = (modelName, actionName) => {
    return `${resourcesAction(modelName, actionName)}_SUCCESS`;
};

export const resourcesActionError = (modelName, actionName) => {
    return `${resourcesAction(modelName, actionName)}_ERROR`
};
